import React from 'react';
import BasicFormField from '../../../common/formFields/basicFormField';
import UploadImageAsset from './UploadImageAsset';

const BrandPageForm = () => (
  <div className="layout">
    <div className="c-heading c-heading--lightgrey c-wrapper u-pv0 u-mt-- u-mb-" >Brand Page Settings</div>
    <UploadImageAsset name="extension.brandLogoImage" label="Logo Image" />
    <UploadImageAsset name="extension.brandBackgroundImage" label="Background Image" />
    <BasicFormField
      placeholder="Name"
      label="Name"
      name="extension.brandName"
      maxLength="255"
    />
    <BasicFormField
      placeholder="Route"
      label="Route"
      name="extension.route"
      maxLength="255"
    />
  </div>
);

export default BrandPageForm;
